let csvw_url;

// 控制全局的host
if (window.location.origin == 'https://www.csvw.com') {
    csvw_url = 'https://www.csvw.com'; // 官网接口地址
}else{
    csvw_url = 'http://47.116.172.203'; // 测试后台接口地址
}

// 控制全局的host
// let state = 'product' // product
// let state = 'dev' // dev
// if (state == 'product') {
//     csvw_url = 'https://www.csvw.com'; // 官网接口地址
// }else{
//     csvw_url = 'http://47.100.255.36'; // 测试后台接口地址
// }

let name = '';

let exhibitioncd_skoda_offline_origin = 'http://www.csvw.com/csvw/thirdpart/video/exhibitioncd-skoda-300-fooline-origin.mp4';
//let exhibitioncd_skoda_offline_origin = 'https://www.csvw.com/u/cms/www/202007/281600522gg0.mp4';

let offline_401 = 'https://www.csvw.com/u/cms/www/202007/231513526N31.mp4';
let offline_402 = 'https://www.csvw.com/u/cms/www/202007/231515090M3S.mp4';
let offline_403 = 'https://www.csvw.com/u/cms/www/202007/23151553p9M0.mp4';
let offline_404 = 'https://www.csvw.com/u/cms/www/202007/23151708Fm61.mp4';
let offline_405 = 'https://www.csvw.com/u/cms/www/202007/23151849RMQt.mp4';
let offline_406 = 'https://www.csvw.com/u/cms/www/202007/23151929v3VD.mp4';
let offline_407 = 'https://www.csvw.com/u/cms/www/202007/23152013G6d4.mp4';
let offline_408 = 'https://www.csvw.com/u/cms/www/202007/23152140CPh1.mp4';
//let offline_409 = 'https://www.csvw.com/u/cms/www/202007/231523222B95.mp4';
let offline_410 = 'https://www.csvw.com/u/cms/www/202007/22115015nWT6.mp4';
let offline_409 = 'https://www.csvw.com/u/cms/www/202007/281600522gg0.mp4';

let skoda_drive_503 = 'http://www.csvw.com/csvw/thirdpart/video/柯迪亚克GT1分钟.mp4';
let skoda_drive_501 = 'http://www.csvw.com/csvw/thirdpart/video/柯迪亚克GT30秒.mp4';
let skoda_drive_504 = 'http://www.csvw.com/csvw/thirdpart/video/柯米克GT1分钟.mp4';
let skoda_drive_502 = 'http://www.csvw.com/csvw/thirdpart/video/柯米克GT30秒.mp4';
// let skoda_drive_301 = 'http://www.csvw.com/csvw/thirdpart/video/试驾柯迪亚克GT长视频.mp4';
// let skoda_drive_302 = 'http://www.csvw.com/csvw/thirdpart/video/试驾柯米克GT长视频.mp4';
let skoda_drive_301 = 'https://www.csvw.com/u/cms/www/202007/281139507W16.mp4';
let skoda_drive_302 = 'https://www.csvw.com/u/cms/www/202007/28114249z9z5.mp4';


let viloran_dirve_001 = 'https://www.csvw.com/u/cms/www/202007/28120156Xj54.mp4';
let viloran_dirve_401 = 'https://www.csvw.com/u/cms/www/202007/28120228d40x.mp4';
let viloran_dirve_402 = 'https://www.csvw.com/u/cms/www/202007/281203449437.mp4';


// phev 千里行
let pbev_101 = "https://www.csvw.com/u/cms/www/202008/18130707PS41.jpg";
let pbev_201 = "https://www.csvw.com/u/cms/www/202008/1916011765Y0.jpg";
let pbev_202 = "https://www.csvw.com/u/cms/www/202008/07130247617y.jpg";
let pbev_203 = "https://www.csvw.com/u/cms/www/202008/11102809N34E.jpg";
let pbev_204 = "https://www.csvw.com/u/cms/www/202008/07132827q048.jpg";
let pbev_301 = "https://www.csvw.com/u/cms/www/202008/18142153Vga2.jpg";
let pbev_302 = "https://www.csvw.com/u/cms/www/202008/071303463U53.jpg";
let pbev_303 = "https://www.csvw.com/u/cms/www/202008/07130402Q718.jpg";
let pbev_304 = "https://www.csvw.com/u/cms/www/202008/07130416U16J.jpg";
let pbev_305 = "https://www.csvw.com/u/cms/www/202008/07130429alN8.jpg";
let pbev_306 = "https://www.csvw.com/u/cms/www/202008/11102131E44t.png";
let pbev_308 = "https://www.csvw.com/u/cms/www/202008/12122252900d.png";
let pbev_307 = "https://www.csvw.com/u/cms/www/202008/201703565o7P.jpg";

let phev2_101 = "https://www.csvw.com/u/cms/www/202008/18130800L0xB.jpg";
let phev2_201 = "https://www.csvw.com/u/cms/www/202008/19160156064B.jpg";
let phev2_202 = "https://www.csvw.com/u/cms/www/202008/11164157K427.png";
let phev2_203 = "https://www.csvw.com/u/cms/www/202008/11164221KeoG.png";
let phev2_204 = "https://www.csvw.com/u/cms/www/202008/111642374EQ1.png";
let phev2_301 = "https://www.csvw.com/u/cms/www/202008/18142224O2wP.jpg";
let phev2_302 = "https://www.csvw.com/u/cms/www/202008/11164309t613.png";
let phev2_303 = "https://www.csvw.com/u/cms/www/202008/111643230eFX.png";
let phev2_304 = "https://www.csvw.com/u/cms/www/202008/111643598e5z.png";
let phev2_305 = "https://www.csvw.com/u/cms/www/202008/11164413nCd9.png";
let phev2_307 = "https://www.csvw.com/u/cms/www/202008/20170303g705.jpg";

let phev3_101 = "https://www.csvw.com/u/cms/www/202008/18130843c98c.jpg";
let phev3_201 = "https://www.csvw.com/u/cms/www/202008/191603046Jl5.jpg";
let phev3_202 = "https://www.csvw.com/u/cms/www/202008/11222646A17K.png";
let phev3_203 = "https://www.csvw.com/u/cms/www/202008/11222704B2k8.png";
let phev3_204 = "https://www.csvw.com/u/cms/www/202008/11222722qI8O.png";
let phev3_301 = "https://www.csvw.com/u/cms/www/202008/211045034757.jpg";
let phev3_302 = "https://www.csvw.com/u/cms/www/202008/11222808332t.png";
let phev3_303 = "https://www.csvw.com/u/cms/www/202008/112228274O0W.png";
let phev3_304 = "https://www.csvw.com/u/cms/www/202008/112228472n91.png";
let phev3_305 = "https://www.csvw.com/u/cms/www/202008/11222904020X.png";
let phev3_307 = "https://www.csvw.com/u/cms/www/202008/11223045t2ne.png";

let phev4_101 = "https://www.csvw.com/u/cms/www/202008/18130909eHMW.jpg";
let phev4_201 = "https://www.csvw.com/u/cms/www/202008/21104342a846.jpg";
let phev4_202 = "https://www.csvw.com/u/cms/www/202008/112232098Hs4.png";
let phev4_203 = "https://www.csvw.com/u/cms/www/202008/1122322747K3.png";
let phev4_204 = "https://www.csvw.com/u/cms/www/202008/11223245IGq3.png";
let phev4_301 = "https://www.csvw.com/u/cms/www/202008/2110443072CF.jpg";
let phev4_302 = "https://www.csvw.com/u/cms/www/202008/1122331705q3.png";
let phev4_303 = "https://www.csvw.com/u/cms/www/202008/112233310Z8M.png";
let phev4_304 = "https://www.csvw.com/u/cms/www/202008/11223408X24e.png";
let phev4_305 = "https://www.csvw.com/u/cms/www/202008/1122342287i2.png";
let phev4_307 = "https://www.csvw.com/u/cms/www/202008/20000817ew86.jpg";

let phev5_101 = "https://www.csvw.com/u/cms/www/202008/181309449W6q.jpg";
let phev5_201 = "https://www.csvw.com/u/cms/www/202008/211123000257.jpg";
let phev5_202 = "https://www.csvw.com/u/cms/www/202008/121137576923.png";
let phev5_203 = "https://www.csvw.com/u/cms/www/202008/12113829V758.png";
let phev5_204 = "https://www.csvw.com/u/cms/www/202008/12113853nC91.png";
let phev5_301 = "https://www.csvw.com/u/cms/www/202008/20001910iRNy.jpg";
let phev5_302 = "https://www.csvw.com/u/cms/www/202008/121139484e3y.png";
let phev5_303 = "https://www.csvw.com/u/cms/www/202008/121140124BE6.png";
let phev5_304 = "https://www.csvw.com/u/cms/www/202008/12114041OJT4.png";
let phev5_305 = "https://www.csvw.com/u/cms/www/202008/12114101lFQm.png";
let phev5_307 = "https://www.csvw.com/u/cms/www/202008/201701186Y9e.jpg";

let phev6_101 = "https://www.csvw.com/u/cms/www/202008/18155828W992.jpg";
let phev6_201 = "https://www.csvw.com/u/cms/www/202008/211123346so6.jpg";
let phev6_202 = "https://www.csvw.com/u/cms/www/202008/1211425681Fq.png";
let phev6_203 = "https://www.csvw.com/u/cms/www/202008/12114313ZUaP.png";
let phev6_204 = "https://www.csvw.com/u/cms/www/202008/12114328E9Fk.png";
let phev6_301 = "https://www.csvw.com/u/cms/www/202008/18142620UX7w.jpg";
let phev6_302 = "https://www.csvw.com/u/cms/www/202008/12114412z3TI.png";
let phev6_303 = "https://www.csvw.com/u/cms/www/202008/1211442932AP.png";
let phev6_304 = "https://www.csvw.com/u/cms/www/202008/121145102u95.png";
let phev6_305 = "https://www.csvw.com/u/cms/www/202008/121145277324.png";
let phev6_307 = "https://www.csvw.com/u/cms/www/202008/20170204PI49.jpg";

// 7
let phev7_101 = "https://www.csvw.com/u/cms/www/202008/181310403I74.jpg";
let phev7_201 = "https://www.csvw.com/u/cms/www/202008/191742123526.jpg";
let phev7_202 = "https://www.csvw.com";
let phev7_203 = "https://www.csvw.com";
let phev7_204 = "https://www.csvw.com";
let phev7_301 = "https://www.csvw.com/u/cms/www/202008/20001840h117.jpg";
let phev7_302 = "https://www.csvw.com";
let phev7_303 = "https://www.csvw.com";
let phev7_304 = "https://www.csvw.com";
let phev7_305 = "https://www.csvw.com";
let phev7_307 = "https://www.csvw.com/u/cms/www/202008/16234732o22F.png";

let phev8_101 = "https://www.csvw.com/u/cms/www/202008/18131108f30A.jpg";
let phev8_201 = "https://www.csvw.com/u/cms/www/202008/19160522qD6C.jpg";
let phev8_202 = "https://www.csvw.com";
let phev8_203 = "https://www.csvw.com";
let phev8_204 = "https://www.csvw.com";
let phev8_301 = "https://www.csvw.com/u/cms/www/202008/18142724758w.jpg";
let phev8_302 = "https://www.csvw.com";
let phev8_303 = "https://www.csvw.com";
let phev8_304 = "https://www.csvw.com";
let phev8_305 = "https://www.csvw.com";
let phev8_307 = "https://www.csvw.com/u/cms/www/202008/200008572gX8.jpg";

let phev9_101 = "https://www.csvw.com/u/cms/www/202008/18131134fwrX.jpg";
let phev9_201 = "https://www.csvw.com/u/cms/www/202008/19174310lWm7.jpg";
let phev9_202 = "https://www.csvw.com";
let phev9_203 = "https://www.csvw.com";
let phev9_204 = "https://www.csvw.com";
let phev9_301 = "https://www.csvw.com/u/cms/www/202008/1814274937Sz.jpg";
let phev9_302 = "https://www.csvw.com";
let phev9_303 = "https://www.csvw.com";
let phev9_304 = "https://www.csvw.com";
let phev9_305 = "https://www.csvw.com";
let phev9_307 = "https://www.csvw.com/u/cms/www/202008/200007200vqV.jpg";

let phev10_101 = "https://www.csvw.com/u/cms/www/202008/18131204l4ps.jpg";
let phev10_201 = "https://www.csvw.com/u/cms/www/202008/19160615JnR2.jpg";
let phev10_202 = "https://www.csvw.com";
let phev10_203 = "https://www.csvw.com";
let phev10_204 = "https://www.csvw.com";
let phev10_301 = "https://www.csvw.com/u/cms/www/202008/18142815r0TN.jpg";
let phev10_302 = "https://www.csvw.com";
let phev10_303 = "https://www.csvw.com";
let phev10_304 = "https://www.csvw.com";
let phev10_305 = "https://www.csvw.com";
let phev10_307 = "https://www.csvw.com/u/cms/www/202008/20170230uTg1.jpg";

let phev11_101 = "https://www.csvw.com/u/cms/www/202008/232211097726.jpg";
let phev11_201 = "https://www.csvw.com/u/cms/www/202008/24112947qld0.jpg";
let phev11_301 = "https://www.csvw.com/u/cms/www/202008/241447170c2I.jpg";
let phev11_307 = "https://www.csvw.com/u/cms/www/202008/241233568325.jpg";


let phev_video_001 = "https://www.csvw.com/u/cms/www/202008/111128274r1M.mp4"; // 传奇西域
let phev_video_002 = "https://www.csvw.com/u/cms/www/202008/11112945Rr33.mp4"; // 天空之境
let phev_video_003 = "https://www.csvw.com/u/cms/www/202008/11113440v680.mp4"; // 黄河明珠
let phev_video_004 = "https://www.csvw.com/u/cms/www/202008/11113529Du1R.mp4"; // 红色基地
let phev_video_005 = "https://www.csvw.com/u/cms/www/202008/1111360201Ue.mp4"; // 千年古都
let phev_video_006 = "https://www.csvw.com/u/cms/www/202008/11113634230b.mp4"; // 兴汉胜境
let phev_video_007 = "https://www.csvw.com/u/cms/www/202008/162342248bLm.mp4"; // 巴蜀韵味
let phev_video_008 = "https://www.csvw.com/u/cms/www/202008/16234333RIL8.mp4"; // 民族风情
let phev_video_009 = "https://www.csvw.com/u/cms/www/202008/16234412T48p.mp4"; // 川西美景
let phev_video_010 = "https://www.csvw.com/u/cms/www/202008/16234444tt1q.mp4"; // 人间秘境
let phev_video_011 = "https://www.csvw.com/u/cms/www/202009/021759340m15.mp4"; // 魔幻山城

export {
    csvw_url, name, exhibitioncd_skoda_offline_origin,
    offline_401, offline_402, offline_403, offline_404, offline_405, offline_406,
    offline_407, offline_408, offline_409, offline_410,
    skoda_drive_501, skoda_drive_502, skoda_drive_503, skoda_drive_504, skoda_drive_301, skoda_drive_302,
    viloran_dirve_001, viloran_dirve_401, viloran_dirve_402,
    pbev_101, pbev_201, pbev_202, pbev_203, pbev_204, pbev_301, pbev_302, pbev_303, pbev_304, pbev_305, pbev_306, pbev_307, pbev_308,
    phev_video_001, phev_video_002, phev_video_003, phev_video_004, phev_video_005, phev_video_006, phev_video_007, phev_video_008, phev_video_009, phev_video_010, phev_video_011,
    phev2_101, phev2_201, phev2_202, phev2_203, phev2_204, phev2_301, phev2_302, phev2_303, phev2_304, phev2_305, phev2_307,
    phev3_101, phev3_201, phev3_202, phev3_203, phev3_204, phev3_301, phev3_302, phev3_303, phev3_304, phev3_305, phev3_307,
    phev4_101, phev4_201, phev4_202, phev4_203, phev4_204, phev4_301, phev4_302, phev4_303, phev4_304, phev4_305, phev4_307,
    phev5_101, phev5_201, phev5_202, phev5_203, phev5_204, phev5_301, phev5_302, phev5_303, phev5_304, phev5_305, phev5_307,
    phev6_101, phev6_201, phev6_202, phev6_203, phev6_204, phev6_301, phev6_302, phev6_303, phev6_304, phev6_305, phev6_307,
    phev7_101, phev7_201, phev7_202, phev7_203, phev7_204, phev7_301, phev7_302, phev7_303, phev7_304, phev7_305, phev7_307,
    phev8_101, phev8_201, phev8_202, phev8_203, phev8_204, phev8_301, phev8_302, phev8_303, phev8_304, phev8_305, phev8_307,
    phev9_101, phev9_201, phev9_202, phev9_203, phev9_204, phev9_301, phev9_302, phev9_303, phev9_304, phev9_305, phev9_307,
    phev10_101, phev10_201, phev10_202, phev10_203, phev10_204, phev10_301, phev10_302, phev10_303, phev10_304, phev10_305, phev10_307,
    phev11_101, phev11_201, phev11_301, phev11_307,

};
